"use client";

import { Flame, Hand, Waves } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurCoreValues() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const values = [{
    number: "01 / 03",
    Icon: Waves,
    title: "Veteran Precision",
    description: "Built on the discipline of service, we approach every business challenge with military-grade precision. We don't just build tools; we engineer systems that ensure your business never misses a beat.",
    practice: "Veteran-owned and operated"
  }, {
    number: "02 / 03",
    Icon: Flame,
    title: "Automated Growth",
    description: "We replace manual bottlenecks with intelligent automation. By deploying 24/7 AI answering and booking, we ensure your business captures every lead, even while you sleep.",
    practice: "24/7 AI-driven lead capture and scheduling"
  }, {
    number: "03 / 03",
    Icon: Hand,
    title: "Premium Craftsmanship",
    description: "Your brand is your reputation. We design custom websites and logos that elevate your local business to a premium status, ensuring you stand out and are recognizable in a crowded market.",
    practice: "High-end design for local market dominance"
  }];
  return <section data-section-id="3556" id="our-core-values" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          
          <h2 className="font-default text-4xl font-bold leading-[1.05] text-foreground tracking-tighter text-center md:text-6xl lg:text-7xl">
            The blueprint for
            <br />
            <span className="italic text-primary">your success.</span>
          </h2>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 relative">
          {values.map((value, i) => {
          const Icon = value.Icon;
          return <div data-index={i} key={i} className={`relative px-6 md:px-10 lg:px-14 py-10 md:py-0 transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${i > 0 ? "md:before:content-[''] md:before:absolute md:before:left-0 md:before:top-[-40px] md:before:bottom-[-40px] md:before:w-px md:before:bg-border" : ""} ${i < values.length - 1 ? "border-b md:border-b-0 border-border pb-12 md:pb-0" : ""} ${i > 0 ? "pt-12 md:pt-0" : ""}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <div className="font-mono font-medium mb-10 md:mb-12" style={{
              fontSize: "40px",
              lineHeight: "1",
              color: "var(--primary)"
            }}>
                  {value.number}
                </div>

                {}
                <div className="mb-10 md:mb-12">
                  <Icon className="w-12 h-12 text-primary" strokeWidth={1.5} aria-hidden="true" />
                </div>

                {}
                <h3 className="font-default text-2xl md:text-[28px] font-semibold text-foreground mb-6 leading-tight tracking-tighter">
                  {value.title}
                </h3>

                {}
                <p className="font-default text-base leading-relaxed text-muted-foreground mb-10 max-w-sm">
                  {value.description}
                </p>

                {}
                <div className="pt-6 border-t border-border">
                  <p className="font-default italic text-sm text-muted-foreground mb-2">
                    Operational focus:
                  </p>
                  <p className="font-mono text-xs leading-relaxed text-foreground tracking-wide">
                    — {value.practice}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}